import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { getAllPartners } from "../../apis/actions/partners.actions";
import { carousselSettings } from "../utils/utils";
import Slider from "react-slick";
import partnerIcon from "../../assets/icons/partners-icon.svg"
const PartenerSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const partners = useSelector((state: RootState) => state?.partners?.partners);

  useEffect(() => {
    dispatch(getAllPartners());
  }, [dispatch]);

  return (
<section className="takaful--partener-container">
  <div className="takaful--partener-title-container">
    <img
      src={partnerIcon} 
      alt="Partners Icon"
      className="takaful--partner-title-icon"
    />
    <span>{t("titles.titleParetner")}</span>
  </div>

  <Slider {...carousselSettings(5 , true)}>
    {partners.map((partner: any, index: number) => (
      <div style={{ textAlign: "center" }} key={index}>
        <figure className="takaful--partner-img-container">
          <img
            src={partner?.image}
            alt="partner"
          />
        </figure>
      </div>
    ))}
  </Slider>
</section>
  );
};

export default PartenerSection;
